export enum EAvailabilityState {
  NO = 'NO',
  PARTIAL = 'PARTIAL',
  FULL = 'FULL',
}
